import React, { useEffect, useState } from "react";
import { db, auth } from "./firebase";
import { collection, getDocs, doc, getDoc } from "firebase/firestore";
import { useAuthState } from "react-firebase-hooks/auth";
import Navbar from "./Navbar";
import "./ReportGestore.css";

function ReportGestore() {
  const [user] = useAuthState(auth);
  const [localeTag, setLocaleTag] = useState("");
  const [periodo, setPeriodo] = useState("oggi");
  const [ordini, setOrdini] = useState([]);
  const [loading, setLoading] = useState(true);

  const [incassoTotale, setIncassoTotale] = useState(0);
  const [numeroOrdini, setNumeroOrdini] = useState(0);
  const [piattiVenduti, setPiattiVenduti] = useState([]);
  const [tavoliAttivi, setTavoliAttivi] = useState([]);
  const [totaleCoperti, setTotaleCoperti] = useState(0);
  const [mediaPerPersona, setMediaPerPersona] = useState(0);
const [giacenzaMediaTavolo, setGiacenzaMediaTavolo] = useState(0);
const [tempoMedioServizio, setTempoMedioServizio] = useState(0);
const [sessioniGiacenzaCalcolate, setSessioniGiacenzaCalcolate] = useState(0);
const [ordiniServizioCalcolati, setOrdiniServizioCalcolati] = useState(0);
const formattaDurata = (minutiTotali) => {
  if (!Number.isFinite(minutiTotali) || minutiTotali <= 0) {
    return "N/D";
  }

  const minutiArrotondati = Math.round(minutiTotali);
  const ore = Math.floor(minutiArrotondati / 60);
  const minuti = minutiArrotondati % 60;

  if (ore === 0) {
    return `${minuti} min`;
  }

  if (minuti === 0) {
    return `${ore} h`;
  }

  return `${ore} h ${minuti} min`;
};
  // Recupera localeTag
  useEffect(() => {
    const fetchLocale = async () => {
      if (!user) return;
      const docRef = doc(db, "utenti", user.uid);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        setLocaleTag(docSnap.data().localeTag);
      }
    };
    fetchLocale();
  }, [user]);

  // Recupera ordini e calcola statistiche
  useEffect(() => {
    const fetchOrdini = async () => {
      if (!localeTag) return;
      setLoading(true);

      try {
      const [
  snapshot,
  snapshotSessioni
] = await Promise.all([
  getDocs(collection(db, "ordini")),
  getDocs(collection(db, "attivazioniSessioni"))
]);

const tutteSessioni = snapshotSessioni.docs
  .map((sessioneDoc) => ({
    id: sessioneDoc.id,
    ...sessioneDoc.data()
  }))
  .filter((sessione) => sessione.locale === localeTag);

const tuttiOrdini = snapshot.docs
          .map((doc) => ({ id: doc.id, ...doc.data() }))
          .filter((o) => o.locale === localeTag)
          .filter((o) => o.stato === "pagamento" || o.stato === "archiviato");

        const ora = new Date();
        let ordiniPeriodo = tuttiOrdini;

        if (periodo === "oggi") {
          const inizio = new Date();
          inizio.setHours(0, 0, 0, 0);
          ordiniPeriodo = tuttiOrdini.filter(
            (o) =>
              o.timestamp?.seconds &&
              new Date(o.timestamp.seconds * 1000) >= inizio
          );
        }

        if (periodo === "settimana") {
          const inizio = new Date();
          inizio.setDate(ora.getDate() - 7);
          inizio.setHours(0, 0, 0, 0);
          ordiniPeriodo = tuttiOrdini.filter(
            (o) =>
              o.timestamp?.seconds &&
              new Date(o.timestamp.seconds * 1000) >= inizio
          );
        }

        if (periodo === "mese") {
          const inizio = new Date();
          inizio.setDate(ora.getDate() - 30);
          inizio.setHours(0, 0, 0, 0);
          ordiniPeriodo = tuttiOrdini.filter(
            (o) =>
              o.timestamp?.seconds &&
              new Date(o.timestamp.seconds * 1000) >= inizio
          );
        }

        setOrdini(ordiniPeriodo);

        const totale = ordiniPeriodo.reduce(
          (sum, o) => sum + (o.totale || 0),
          0
        );
        setIncassoTotale(totale);
        setNumeroOrdini(ordiniPeriodo.length);

        const coperti = ordiniPeriodo.reduce(
          (sum, o) => sum + (o.coperti || 0),
          0
        );
        setTotaleCoperti(coperti);
        setMediaPerPersona(coperti > 0 ? totale / coperti : 0);

        // Piatti
        const piattiMap = {};
        ordiniPeriodo.forEach((ordine) => {
          (ordine.items || []).forEach((item) => {
            if (!piattiMap[item.name]) {
              piattiMap[item.name] = { nome: item.name, quantita: 0, incasso: 0 };
            }
            piattiMap[item.name].quantita += item.quantity || 0;
            piattiMap[item.name].incasso +=
              (item.quantity || 0) * (item.price || 0);
          });
        });

        setPiattiVenduti(
          Object.values(piattiMap).sort((a, b) => b.quantita - a.quantita)
        );

        // Tavoli
        const tavoliMap = {};
        ordiniPeriodo.forEach((ordine) => {
          if (!tavoliMap[ordine.table]) {
            tavoliMap[ordine.table] = {
              tavolo: ordine.table,
              numeroOrdini: 0,
              incasso: 0,
              coperti: 0,
            };
          }
          tavoliMap[ordine.table].numeroOrdini++;
          tavoliMap[ordine.table].incasso += ordine.totale || 0;
          tavoliMap[ordine.table].coperti += ordine.coperti || 0;
        });

setTavoliAttivi(
  Object.values(tavoliMap).sort((a, b) => b.incasso - a.incasso)
);

/* =========================================
   GIACENZA MEDIA AL TAVOLO
   Dalla prima scansione QR al pagamento
========================================= */

const sessioniGiaCalcolate = new Set();
const durateGiacenza = [];

ordiniPeriodo.forEach((ordine) => {
  const isAsporto =
    String(ordine.tipoOrdine || "").toUpperCase() === "ASPORTO" ||
    ordine.numeroOrdineAsporto != null ||
    String(ordine.table || "")
      .toUpperCase()
      .startsWith("ASPORTO-");

  if (isAsporto) return;
  if (!ordine.token) return;
  if (!ordine.pagatoIl?.seconds) return;

  const chiaveSessione =
    `${ordine.locale}_${ordine.table}_${ordine.token}`;

  if (sessioniGiaCalcolate.has(chiaveSessione)) {
    return;
  }

  const sessione = tutteSessioni.find((s) =>
    String(s.locale) === String(ordine.locale) &&
    String(s.tavolo) === String(ordine.table) &&
    String(s.token) === String(ordine.token)
  );

  if (!sessione?.creatoIl?.seconds) return;

  const inizioSessione =
    sessione.creatoIl.seconds * 1000;

  const pagamento =
    ordine.pagatoIl.seconds * 1000;

  const durataMinuti =
    (pagamento - inizioSessione) / 1000 / 60;

  if (
    durataMinuti >= 0 &&
    durataMinuti <= 24 * 60
  ) {
    durateGiacenza.push(durataMinuti);
    sessioniGiaCalcolate.add(chiaveSessione);
  }
});

const mediaGiacenza =
  durateGiacenza.length > 0
    ? durateGiacenza.reduce(
        (somma, durata) => somma + durata,
        0
      ) / durateGiacenza.length
    : 0;

setGiacenzaMediaTavolo(mediaGiacenza);
setSessioniGiacenzaCalcolate(durateGiacenza.length);

/* =========================================
   TEMPO MEDIO ORDINI SERVITI
   Sala: timestamp → servitoCompletamenteAt
   Asporto: timestamp → prontoAt
========================================= */

const durateServizio = [];

ordiniPeriodo.forEach((ordine) => {
  if (!ordine.timestamp?.seconds) return;

  const isAsporto =
    String(ordine.tipoOrdine || "").toUpperCase() === "ASPORTO" ||
    ordine.numeroOrdineAsporto != null ||
    String(ordine.table || "")
      .toUpperCase()
      .startsWith("ASPORTO-");

  const fineServizio = isAsporto
    ? ordine.prontoAt
    : ordine.servitoCompletamenteAt;

  if (!fineServizio?.seconds) return;

  const arrivoOrdine =
    ordine.timestamp.seconds * 1000;

  const completamento =
    fineServizio.seconds * 1000;

  const durataMinuti =
    (completamento - arrivoOrdine) / 1000 / 60;

  if (
    durataMinuti >= 0 &&
    durataMinuti <= 24 * 60
  ) {
    durateServizio.push(durataMinuti);
  }
});

const mediaServizio =
  durateServizio.length > 0
    ? durateServizio.reduce(
        (somma, durata) => somma + durata,
        0
      ) / durateServizio.length
    : 0;

setTempoMedioServizio(mediaServizio);
setOrdiniServizioCalcolati(durateServizio.length);

setLoading(false);
      } catch (err) {
        console.error("Errore fetch ordini:", err);
        setLoading(false);
      }
    };

    fetchOrdini();
  }, [localeTag, periodo]);

  const esportaCSV = () => {
    if (ordini.length === 0) return;

    const header =
      "Data,Tavolo,Stato,Coperti,Totale,Media per Persona,Piatti\n";

    const righe = ordini.map((o) => {
      const data = o.timestamp?.seconds
        ? new Date(o.timestamp.seconds * 1000).toLocaleString("it-IT")
        : "N/A";

      const piatti = (o.items || [])
        .map((item) => `${item.quantity}x ${item.name}`)
        .join("; ");

      const coperti = o.coperti || 0;
      const mediaPersona =
        coperti > 0 ? (o.totale / coperti).toFixed(2) : "N/A";

      return `"${data}","${o.table}","${o.stato}","${coperti}","€${(
        o.totale || 0
      ).toFixed(2)}","€${mediaPersona}","${piatti}"`;
    });

    const csv = header + righe.join("\n");
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `report_${periodo}_${
      new Date().toISOString().split("T")[0]
    }.csv`;
    link.click();
  };

  return (
    <>
      <Navbar />

      <div className="report-page">
        <h2 className="report-title">📊 Report Gestore</h2>

        <div className="report-filters">
          {["oggi", "settimana", "mese", "tutto"].map((p) => (
            <button
              key={p}
              onClick={() => setPeriodo(p)}
              className={`report-btn ${periodo === p ? "active" : ""}`}
            >
              {p === "oggi"
                ? "📅 Oggi"
                : p === "settimana"
                ? "📆 Ultima settimana"
                : p === "mese"
                ? "🗓️ Ultimo mese"
                : "🌐 Tutto"}
            </button>
          ))}

          <button
            onClick={esportaCSV}
            disabled={ordini.length === 0}
            className="report-btn export"
          >
            📥 Esporta CSV
          </button>
        </div>

        {loading ? (
          <p>Caricamento dati...</p>
        ) : (
          <>
            <div className="report-kpi-grid">
              <div className="report-card border-green">
                <div className="report-card-title">💰 Incasso Totale</div>
                <div className="report-card-value">€{incassoTotale.toFixed(2)}</div>
              </div>
              <div className="report-card border-blue">
                <div className="report-card-title">📦 Ordini Serviti</div>
                <div className="report-card-value">{numeroOrdini}</div>
              </div>
              <div className="report-card border-purple">
                <div className="report-card-title">🍽️ Piatti Venduti</div>
                <div className="report-card-value">{piattiVenduti.reduce((sum, p) => sum + p.quantita, 0)}</div>
              </div>
              <div className="report-card border-yellow">
                <div className="report-card-title">👥 Coperti Totali</div>
                <div className="report-card-value">{totaleCoperti}</div>
              </div>
              <div className="report-card border-orange">
                <div className="report-card-title">💵 Media per Persona</div>
                <div className="report-card-value">€{mediaPerPersona.toFixed(2)}</div>
              </div>
              <div className="report-card border-cyan">
                <div className="report-card-title">📊 Media Ordine</div>
                <div className="report-card-value">€{numeroOrdini > 0 ? (incassoTotale / numeroOrdini).toFixed(2) : "0.00"}</div>
              </div>
            </div>

            {/* Piatti più venduti */}
            <div className="report-section">
              <div className="report-section-title">🏆 Piatti più venduti</div>
              {piattiVenduti.length === 0 ? (
                <p>Nessun piatto venduto in questo periodo.</p>
              ) : (
                <div className="report-grid">
                  {piattiVenduti.slice(0, 8).map((piatto, idx) => (
                    <div key={idx} className="report-item-card">
                      <div className="report-item-title">
                        {idx === 0 ? "🥇 " : idx === 1 ? "🥈 " : idx === 2 ? "🥉 " : ""}
                        {piatto.nome}
                      </div>
                      <div className="report-item-sub">{piatto.quantita} venduti</div>
                      <div className="report-item-value">€{piatto.incasso.toFixed(2)}</div>
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* Tavoli più attivi */}
            <div className="report-section">
              <div className="report-section-title">🪑 Tavoli più attivi</div>
              {tavoliAttivi.length === 0 ? (
                <p>Nessun tavolo attivo in questo periodo.</p>
              ) : (
                <div className="report-grid">
                  {tavoliAttivi.slice(0, 6).map((tavolo, idx) => (
                    <div key={idx} className="report-item-card">
                      <div className="report-item-title">Tavolo {tavolo.tavolo}</div>
                      <div className="report-item-sub">{tavolo.numeroOrdini} ordini • {tavolo.coperti} coperti</div>
                      <div className="report-item-value">€{tavolo.incasso.toFixed(2)}</div>
                      {tavolo.coperti > 0 && (
                        <div className="report-item-sub">€{(tavolo.incasso / tavolo.coperti).toFixed(2)} / persona</div>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
{/* Tempi medi operativi */}
<div className="report-section">
  <div className="report-section-title">
    ⏱️ Tempi medi operativi
  </div>

  <div className="report-grid">
    <div className="report-item-card">
      <div className="report-item-title">
        🪑 Giacenza media al tavolo
      </div>

      <div className="report-item-sub">
        Dalla prima scansione del QR al pagamento
      </div>

      <div className="report-item-value">
        {formattaDurata(giacenzaMediaTavolo)}
      </div>

      <div className="report-item-sub">
        {sessioniGiacenzaCalcolate > 0
          ? `${sessioniGiacenzaCalcolate} sessioni calcolate`
          : "Nessuna sessione completa disponibile"}
      </div>
    </div>

    <div className="report-item-card">
      <div className="report-item-title">
        🍽️ Tempo medio ordini serviti
      </div>

      <div className="report-item-sub">
        Dall'arrivo in cucina al servizio o al pronto asporto
      </div>

      <div className="report-item-value">
        {formattaDurata(tempoMedioServizio)}
      </div>

      <div className="report-item-sub">
        {ordiniServizioCalcolati > 0
          ? `${ordiniServizioCalcolati} ordini calcolati`
          : "Nessun ordine completo disponibile"}
      </div>
    </div>
  </div>
</div>
            {/* Storico ordini */}
            <div className="report-section">
              <div className="report-section-title">📋 Storico ordini</div>
              {ordini.length === 0 ? (
                <p>Nessun ordine in questo periodo.</p>
              ) : (
                <div className="report-grid">
                  {ordini.slice(0, 10).map((ordine, idx) => (
                    <div key={idx} className="report-item-card">
                      <div className="report-item-title">Tavolo {ordine.table}</div>
                      <div className="report-item-sub">{ordine.coperti} coperti • {ordine.items?.length || 0} piatti</div>
                      <div className="report-item-value">€{(ordine.totale || 0).toFixed(2)}</div>
                      <div className="report-item-sub">
                        {ordine.timestamp?.seconds
                          ? new Date(ordine.timestamp.seconds * 1000).toLocaleString("it-IT")
                          : "N/A"}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </>
        )}
      </div>
    </>
  );
}

export default ReportGestore;